export const chn2eng = {
    '物体语义': 'Data Items',
    '领域语义': 'Data Attributes',
    '属性语义': 'Data Facts',
    '关系语义': 'Data Relationships',
    '情感': 'Evoke Emotion',
    '数据': 'Explain Data',
    '主题': 'Illustrate Topics',
    '形状映射': 'Appearance',
    '轮廓映射': 'Silhouette',
    '结构映射': 'Structure',
    '方位映射': 'Orientation',
    '颜色映射': 'Color',
    '状态映射': 'Status',
    '功能映射': 'Function',
    '过程映射': 'Process',
}


export const eng2chn = {
    'Data Items': '物体语义',
    'Data Attributes': '领域语义',
    'Data Facts': '属性语义',
    'Data Relationships': '关系语义',
    'Evoke Emotion': '情感',
    'Explain Data': '数据',
    'Illustrate Topics': '主题',
    'Appearance': '形状映射',
    'Silhouette': '轮廓映射',
    'Structure': '结构映射',
    'Orientation': '方位映射',
    'Color': '颜色映射',
    'Status': '状态映射',
    'Function': '功能映射',
    'Process': '过程映射',
}

export const translate2chn = (eng) => {
    return eng;
    // return {
    //     'Data Items': '数据项',
    //     'Data Attributes': '数据领域',
    //     'Data Facts': '数据特征',
    //     'Data Relationships': '数据关系',
    //     'Evoke Emotion': '唤起情感',
    //     'Explain Data': '解释数据',
    //     'Illustrate Topics': '联系背景',
    //     'Appearance': '形状映射',
    //     'Silhouette': '轮廓映射',
    //     'Structure': '结构映射',
    //     'Orientation': '方位映射',
    //     'Color': '颜色映射',
    //     'Status': '状态映射',
    //     'Function': '功能映射',
    //     'Process': '过程映射',
    // }[eng];
}

export const introduction = {
    "Data Items": {
        "description_zh": "这类隐喻直接用具体的物体代表数据项，让读者一眼理解数据。例如，在柱状图中，有的柱子是花的数据，有的柱子是草的数据，可以用花草的icon直接替代数据项的名称。",
        "description": "A data item refers to a distinct, individual entity, such as a row in a table.",
        "examples": [
            {
                "name": "678.png",
                "description": "Type of each non-alcoholic beverage brands."
            },
            {
                "name": "271.png",
                "description": "Type of each sushi."
            },
            {
                "name": "489.png",
                "description": "Type of each pizza."
            }
        ]
    },
    "Data Attributes": {
        "description_zh": "这类隐喻用熟悉的概念来表达数据所属的类别或领域。例如，在做一张环保主题的信息图表设计时，用树叶、地球等图案可以强调数据与环境相关。",
        "description": "A data attribute is a measurable, observable, or recordable property of data, such as a table column.",
        "examples": [
            {
                "name": "43.png",
                "description": "Domain of wine."
            },
            {
                "name": "139.png",
                "description": "Domain of energy consumption."
            },
            {
                "name": "147.png",
                "description": "Domain of film."
            }
        ]
    },
    "Data Facts": {
        "description_zh": "这类隐喻用于表现数据的特征，比如数据的大小、上升或下降的趋势、分布等。相较于直接用数字，图形化的视觉隐喻可以让读者更直观地理解数据的含义。",
        "description": "A data fact is a concise, human-interpretable insight derived from raw data that describes data trends, distributions, extremes, or anomalies.",
        "examples": [
            {
                "name": "177.png",
                "description": "The data distribution of wages across different countries."
            },
            {
                "name": "52.png",
                "description": "The fact of Denmark having the highest electricity tax."
            },
            {
                "name": "167.png",
                "description": "The increasing load of national tax and social security burden on citizens."
            }
        ]
    },
    "Data Relationships": {
        "description_zh": "这类隐喻用于表现数据中存在的关系，如数据的层级关系、时序关系、网状关系等，以及数据中存在的比较、对立、竞争等关系。比如，在可视化两个政党的支持率时，可用两只互相吠叫的狗来比喻它们的对立关系。",
        "description": "This type of data semantics represents the relationships between pairs of entities.",
        "examples": [
            {
                "name": "64.png",
                "description": "The split and merge relationship of multiple topics in publications."
            },
            {
                "name": "634.png",
                "description": "The temporal relationship of the human evolution."
            },
            {
                "name": "138.png",
                "description": "The hierarchical relationship of geographical locations, and the relationship of sources and uses."
            }
        ]
    },
    "Illustrate Topics": {
        "description_zh": "这类视觉隐喻的核心目标是加强信息图表的主题表达，通过选择与主题高度契合的视觉元素，设计师能够突出关键信息，引导读者更直观地理解核心内容。",
        "description": "This goal focuses on illustrating data topics through graphical elements that offer background information.",
        "examples": [
            {
                "name": "1153.png",
                "description": "The topic of upward mobility in Gen Z."
            },
            {
                "name": "26.png",
                "description": "The topic of rice production."
            },
            {
                "name": "43.png",
                "description": "The topic of wine consumption."
            }
        ]
    },
    "Explain Data": {
        "description_zh": "这类视觉隐喻的核心目标是强调数据趋势、分布和比较等信息的表达，通过借助读者熟悉的视觉设计来对数据进行比喻，使抽象的信息更易理解。",
        "description": "This goal aims to facilitate the audience’s understanding of abstract data and deriving insights.",
        "examples": [
            {
                "name": "12.png",
                "description": "The hierarchical relationship of geographical locations."
            },
            {
                "name": "143.png",
                "description": "The enormous value is emphasized with a place higher than satellites."
            },
            {
                "name": "198.png",
                "description": "The comparison of divorce number count in 1999 and 2020."
            }
        ]
    },
    "Evoke Emotion": {
        "description_zh": "这类视觉隐喻的核心目标是激发读者的情感共鸣，通过利用读者对具象物体的情感反应，使数据表达的不仅仅是理性信息，还能触动观众的情绪，引起关注。",
        "description": "This goal aims to evoke emotion in the audience.",
        "examples": [
            {
                "name": "1.png",
                "description": "The sadness emotion behind Iraq conflicts fatalities."
            },
            {
                "name": "27.png",
                "description": "The discomfort of being monitored."
            },
            {
                "name": "737.png",
                "description": "The feeling of annoyance toward some Facebook friends."
            }
        ]
    },
    "Appearance": {
        "description_zh": "这类隐喻方法直接利用物体的外观特征来传达信息。例如，用花的图案来表现花朵信息图表的主题；花的形状和饼状图类似，可以用花瓣的大小来比喻饼状图中数据的多少。",
        "description": "This mapping directly applies the appearance of graphical representations to convey data semantics.",
        "examples": [
            {
                "name": "271.png",
                "description": "The appearance of each sushi."
            },
            {
                "name": "289.png",
                "description": "The appearance of a sneaker."
            },
            {
                "name": "311.png",
                "description": "The appearance of coal."
            }
        ]
    },
    "Silhouette": {
        "description_zh": "这类隐喻方法利用物体的轮廓与可视化图表相结合，使信息图表具有视觉趣味性。例如，如果一个花朵主题的折线图正好长得很像花朵，可以把它们的形状做同构。",
        "description": "This category uses the contour lines of a graphical representation to establish mappings.",
        "examples": [
            {
                "name": "264.png",
                "description": "The silhouette of a woman with pregnant belly."
            },
            {
                "name": "464.png",
                "description": "The silhouette of a diving man."
            },
            {
                "name": "975.png",
                "description": "The silhouette of a wildfire."
            }
        ]
    },
    "Structure": {
        "description_zh": "这类隐喻方法利用物体的结构来表现数据的层级关系。例如，可以使用树状结构来呈现层级数据，可以借助树的枝干分叉形态直观地展示数据的关系网络。",
        "description": "Visual structures, such as the connectivity structure of a network, can be used to map to data semantics.",
        "examples": [
            {
                "name": "12.png",
                "description": "The tree structure of a dandelion."
            },
            // {
            //     "name": "564.png",
            //     "description": "The tree structure of a tree."
            // },
            {
                "name": "313.png",
                "description": "The connectivity structure of a metro system."
            },
            {
                "name": "2135.png",
                "description": "The layered containment structure of a planet."
            }
        ]
    },
    "Orientation": {
        "description_zh": "这类隐喻方法利用方向的象征意义来传达信息。例如，向上表示积极、向下表示消极；可以用一个陡峭的山坡，从低处到高处标注不同数据点，以比喻数据的上升趋势。",
        "description": "This mapping refers to using perceived orientation to convey data semantics.",
        "examples": [
            {
                "name": "1.png",
                "description": "The inverted y-axis of the bar chart."
            },
            {
                "name": "282.png",
                "description": "The downward trajectory of bikers descending a mountain."
            },
            {
                "name": "1153.png",
                "description": "The upward orientation of a ladder."
            }
        ]
    },
    "Color": {
        "description_zh": "这类隐喻方法利用颜色的象征意义来传达信息。例如，在文化含义中，红色常与紧急情况相关，绿色象征环境保护；在物体外观方面，也可以用绿色比喻草。",
        "description": "Colors evoke strong cultural and emotional associations.",
        "examples": [
            {
                "name": "701.png",
                "description": "The red color of animals."
            },
            // {
            //     "name": "974.png",
            //     "description": "The red color of the voronoi treemap."
            // },
            {
                "name": "1029.png",
                "description": "The green color of bars to represent forests."
            },
            {
                "name": "990.png",
                "description": "The green and orange colors of bars to symbolize clean and fossil energy."
            }
        ]
    },
    "Status": {
        "description_zh": "这类隐喻方法利用物体的状态变化来传达信息。例如，花朵的枯萎状态可以用于比喻下降衰退的数据，而花朵的盛开状态可以用于比喻上升增长的数据。",
        "description": "The status of a concept refers to its condition or situation, such as a horse in motion, an unplugged plug, or a worried expression on a person. ",
        "examples": [
            {
                "name": "24.png",
                "description": "The status of the plugs showing the exit of American companies."
            },
            // {
            //     "name": "54.png",
            //     "description": "The melting status of the Earth showing the effect of carbon emissions."
            // },
            {
                "name": "136.png",
                "description": "The status of ships sinking."
            },
            {
                "name": "192.png",
                "description": "The status of warriors charging forward or lying."
            }
        ]
    },
    "Function": {
        "description_zh": "这类隐喻方法利用物体的功能特性来传达信息。例如，在一个汉堡主题的信息图表里，可以用叉子形状的柱状图来比喻汉堡数据，因为夹汉堡是叉子的一个功能应用。",
        "description": "The function of a concept refers to its practical or intended use, or what it can result in.",
        "examples": [
            {
                "name": "45.png",
                "description": "The function of forks for use in eating."
            },
            {
                "name": "139.png",
                "description": "The function of a wire for charging electricity."
            },
            // {
            //     "name": "12.png",
            //     "description": "The function of a dandelion for spreading seeds."
            // },
            {
                "name": "262.png",
                "description": "The function of gas stations for refueling oil."
            }
        ]
    },
    "Process": {
        "description_zh": "这类隐喻方法利用物体所的行为过程来传达信息。例如，人向上爬的动作过程可以用于比喻上升增长的数据，而人向下爬楼梯的过程可以用于比喻下降衰退的数据。",
        "description": "A process refers to a series of actions, changes, or steps that unfold over time.",
        "examples": [
            {
                "name": "131.png",
                "description": "The process of water flowing into a vortex."
            },
            {
                "name": "424.png",
                "description": "The process of sand flowing down in a hourglass."
            },
            {
                "name": "483.png",
                "description": "The process of ketchup being spilled from the bottle."
            }
        ]
    }
};

